import * as Yup from 'yup';
import { UFormGovService, UFormGovAgenda } from '../../models';

export function useValidationSchema() {
  return Yup.object<UFormGovService>().shape({
    name: Yup.string().nullable().required('Povinné pole'),
    externalId: Yup.string().optional(),
    description: Yup.string().optional(),
    note: Yup.string().optional(),
    agenda: Yup.object<UFormGovAgenda>().optional(),
  });
}
